import artwork from "../../../assets/models-src/environment/conservatory_root_burrow.json";
import { conservatoryActorSupportY, OVERGROWN_CONSERVATORY_PLATFORMS, type ConservatoryActorSupport } from "../layouts/OvergrownConservatoryPlatforms";

/** Fit visible bedding on its real deck; the logical nest/capture target stays put. */
export function conservatoryBurrowPlacement(logicalX: number, support: ConservatoryActorSupport = "ground") {
  const floorY = conservatoryActorSupportY(support);
  if (support === "ground") return { floorY, rack: false, offsetX: 0 };
  const deck = OVERGROWN_CONSERVATORY_PLATFORMS.platforms.find(p => p.name === support)!;
  const min = deck.x - deck.w / 2 - artwork.beddingBoundsX.min + .025;
  const max = deck.x + deck.w / 2 - artwork.beddingBoundsX.max - .025;
  return { floorY, rack: true, offsetX: Math.max(min, Math.min(max, logicalX)) - logicalX };
}
